import React from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { ScrollArea } from "@/components/ui/scroll-area";
interface EntityLightboxProps {
  title: string;
  variant?: "shop" | "tavern" | "loot";
  children: React.ReactNode;
  onClose: () => void;
}
const EntityLightbox: React.FC<EntityLightboxProps> = ({
  title,
  children,
  onClose
}) => {
  return <Dialog open={true} onOpenChange={onClose} data-sentry-element="Dialog" data-sentry-component="EntityLightbox" data-sentry-source-file="index.tsx">
            <DialogContent className="max-w-4xl w-full p-0 gap-0" data-sentry-element="DialogContent" data-sentry-source-file="index.tsx">
                <DialogHeader className="p-4 sm:p-6 border-b border-slate-700" data-sentry-element="DialogHeader" data-sentry-source-file="index.tsx">
                    <DialogTitle className="text-xl font-semibold" data-sentry-element="DialogTitle" data-sentry-source-file="index.tsx">
                        {title}
                    </DialogTitle>
                </DialogHeader>
                <ScrollArea className="max-h-[80vh] p-4 sm:p-6" data-sentry-element="ScrollArea" data-sentry-source-file="index.tsx">
                    {children}
                </ScrollArea>
            </DialogContent>
        </Dialog>;
};
export default EntityLightbox;